export enum CourseLmsProfileType {
  Optional = 0,
  Required = 1,
}

const { Optional, Required } = CourseLmsProfileType

export const getTranslationKeyCourseLmsProfile = (
  modality: CourseLmsProfileType
) => {
  const modalities = {
    [Optional]: 'optional',
    [Required]: 'required',
  }
  return modalities[modality] || modalities[Optional]
}
